import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { of } from "rxjs";
import { catchError, map, switchMap } from "rxjs/operators";

import { ConsumerService } from "../../../services/api/consumer.service";
import { ConsumerActions } from "../../actions/consumer.actions";
import { FailState } from "../../models/fail-state";

@Injectable()
export class ConsumerAccountRemoveEffects {
	remove = createEffect(() =>
		this.actions.pipe(
			ofType(ConsumerActions.account.remove),
			switchMap(() =>
				this.consumerService.accountRemove().pipe(
					map(() => ConsumerActions.account.removeSuccess()),
					catchError((error) =>
						of(ConsumerActions.account.removeFail(new FailState(error)))
					)
				)
			)
		)
	);

	constructor(
		private actions: Actions,
		private consumerService: ConsumerService
	) {}
}
